import { Box, Loader, TextButton, Tooltip } from '@wix/design-system';
import { SparklesFilledSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
export const GenerateAiSuffixButton = _ref => {
  let {
    label,
    generatingLabel,
    isGenerating = false,
    isDisabled = false,
    disabledTooltip,
    onClick,
    onTooltipShow
  } = _ref;
  const buttonDisabled = isGenerating || isDisabled;
  const showTooltip = !!disabledTooltip && isDisabled;
  const showGeneratingState = isGenerating && !isDisabled;
  const button = /*#__PURE__*/React.createElement(Box, {
    maxWidth: "120px"
  }, /*#__PURE__*/React.createElement(TextButton, {
    dataHook: "generate-ai-suffix-button",
    disabled: buttonDisabled,
    prefixIcon: showGeneratingState ?
    /*#__PURE__*/
    // TODO: consider replacing px with SP token
    React.createElement(Box, {
      paddingRight: "3px"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "tiny"
    })) : /*#__PURE__*/React.createElement(SparklesFilledSmall, null),
    size: "tiny",
    ellipsis: true,
    onClick: onClick
  }, showGeneratingState ? generatingLabel : label));
  if (showTooltip) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: /*#__PURE__*/React.createElement(Box, {
        align: "left",
        direction: "vertical",
        gap: "SP2"
      }, disabledTooltip),
      dataHook: "generate-ai-suffix-tooltip",
      size: "small",
      onShow: onTooltipShow
    }, button);
  }
  return button;
};
//# sourceMappingURL=generate-ai-suffix-button.js.map